import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useNavigate } from 'react-router-dom';
import { useSetState } from 'react-use';
import NoApps from '../../../../../images/no-messenger-apps.png';
import { CardTitle } from './components/card-title';
import { EmptyScreen } from './components/empty-screen';
import { Wizard } from './components/wizard';
import { AddPageForm } from './steps/AddPageForm';
import { AddPageGuide } from './steps/AddPageGuide';
import { AppSetupForm } from './steps/AppSetupForm';
import { AppSetupGuide } from './steps/AppSetupGuide';
import { HooksForm } from './steps/HooksForm';
import { HooksGuide } from './steps/HooksGuide';
import { PublishForm } from './steps/PublishForm';
import { PublishGuide } from './steps/PublishGuide';
import './messaging.less';
export const MessagingAddApp = (props) => {
    const navigate = useNavigate();
    const [state, setState] = useSetState({
        step: 0,
        appId: null,
    });
    const handleStartClick = () => {
        setState({
            step: 1,
        });
    };
    const handleFormSuccess = (appId) => {
        setState({
            step: 2,
            appId,
        });
    };
    const handleHooksSuccess = () => {
        setState({
            step: 3,
        });
    };
    const handlePageFormSuccess = () => {
        setState({
            step: 4,
        });
    };
    const handlePublishSuccess = () => {
        navigate('/settings/messaging');
    };
    const { step } = state;
    const showIntro = step === 0;
    const showForm = step === 1;
    const showHooks = step === 2;
    const showAddPage = step === 3;
    const showPublish = step === 4;
    return (_jsxs("div", Object.assign({ className: "content-panel messenger-settings" }, { children: [_jsx(CardTitle, Object.assign({ backLink: _jsx(Link, Object.assign({ to: "/settings/messaging" }, { children: "Back to settings" })) }, { children: "Setup Facebook messenger" })), _jsxs("div", Object.assign({ className: "content" }, { children: [showIntro && (_jsx(EmptyScreen, { headline: "Things you need to setup Facebook Messenger:", image: NoApps, imageAlt: 'Setup Facebook Messenger', buttonClick: handleStartClick, buttonText: "Continue", ingredients: {
                            'Facebook Page': 'https://www.facebook.com/business/learn/set-up-facebook-page',
                            'Facebook for Developers account': 'https://developers.facebook.com/',
                            'Create a Facebook Business Manager': 'https://www.facebook.com/business/help/1710077379203657',
                            'Verify the Facebook Business Manager': 'https://www.facebook.com/business/help/2058515294227817',
                        } })), showForm && (_jsx(Wizard, { guide: _jsx(AppSetupGuide, {}), form: _jsx(AppSetupForm, { addApp: props.addApp, onSuccess: handleFormSuccess }) })), showHooks && (_jsx(Wizard, { guide: _jsx(HooksGuide, {}), form: _jsx(HooksForm, { appId: state.appId, callback: props.callbackUrl, token: props.verificationToken, getHooks: props.getHooks, onSuccess: handleHooksSuccess }) })), showAddPage && (_jsx(Wizard, { guide: _jsx(AddPageGuide, {}), form: _jsx(AddPageForm, { appId: state.appId, addPage: props.addPage, onSuccess: handlePageFormSuccess, queues: props.queues }) })), showPublish && (_jsx(Wizard, { guide: _jsx(PublishGuide, {}), form: _jsx(PublishForm, { onSuccess: handlePublishSuccess }) }))] }))] })));
};
